/* LATE — Combined main.js + shop.js (built for Shopify) */

/* ============ MAIN ============ */
/* ============================================================
   LATE — main.js
   Hero word-swap, marquee, reveals, fold loop, FAQ, nav
   ============================================================ */

(function(){
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Page-in fade
  requestAnimationFrame(()=> document.body.classList.add('ready'));

  // ---------- Nav scroll state + mobile menu ----------
  const nav = document.querySelector('.nav');
  if(nav){
    const onScroll = ()=> nav.classList.toggle('scrolled', window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }
  const burger = document.querySelector('.hamburger');
  const menu = document.querySelector('.mobile-menu');
  if(burger && menu){
    burger.addEventListener('click', ()=>{
      const open = burger.classList.toggle('open');
      menu.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    menu.querySelectorAll('a').forEach(a=> a.addEventListener('click', ()=>{
      burger.classList.remove('open');menu.classList.remove('open');document.body.style.overflow='';
    }));
  }

  // ---------- Hero word-swap sequence (looping) ----------
  const swap = document.querySelector('.swap');
  if(swap){
    const words = ['light','late','Late.'];
    const slot = swap;

    function placeWord(text, isFinal){
      const span = document.createElement('span');
      span.className = 'word in';
      span.textContent = text;
      slot.appendChild(span);
      if(isFinal){
        const wipe = document.createElement('span');
        wipe.className = 'wipe';
        slot.appendChild(wipe);
        setTimeout(()=> wipe.classList.add('go'), 200);
      }
    }
    function exitCurrent(){
      const current = slot.querySelector('.word.in');
      if(current){
        current.classList.remove('in');
        current.classList.add('out');
        setTimeout(()=> current.remove(), 320);
      }
    }
    function exitWipe(){
      const wipe = slot.querySelector('.wipe');
      if(wipe){
        wipe.classList.add('exit');
        setTimeout(()=> wipe.remove(), 500);
      }
    }

    let i = 0;
    function step(){
      const isFinal = (i === words.length - 1);
      placeWord(words[i], isFinal);
      if(!isFinal){
        setTimeout(()=>{
          exitCurrent();
          setTimeout(()=>{ i++; step(); }, 160);
        }, 1200);
      } else {
        // Hold "Late." + wipe, then loop back to "light"
        setTimeout(()=>{
          exitWipe();
          exitCurrent();
          setTimeout(()=>{ i = 0; step(); }, 480);
        }, 2600);
      }
    }

    if(reduce){
      const span = document.createElement('span');
      span.className = 'word';
      span.textContent = 'Late.';
      span.style.transform='none';span.style.opacity='1';
      slot.appendChild(span);
    } else {
      setTimeout(step, 500);
    }
  }

  // ---------- Marquee: duplicate content for seamless loop ----------
  const mtrack = document.querySelector('.marquee-track');
  if(mtrack){
    mtrack.innerHTML += mtrack.innerHTML;
  }

  // ---------- Reveal-on-scroll ----------
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('in');
        // Count-up for caliper values inside revealed compare blocks
        e.target.querySelectorAll('[data-count]').forEach(el=>{
          if(el.dataset.done) return;
          el.dataset.done = '1';
          const target = parseFloat(el.dataset.count);
          const dur = 1200, t0 = performance.now() + 700;
          function step(now){
            const t = Math.max(0, now - t0);
            const p = Math.min(1, t/dur);
            const eased = 1 - Math.pow(1-p, 3);
            el.textContent = (target * eased).toFixed(1);
            if(p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
        io.unobserve(e.target);
      }
    });
  },{threshold:.18});
  document.querySelectorAll('[data-reveal]').forEach(el=> io.observe(el));

  // ---------- Evolution image reveal (handled by generic [data-reveal] + CSS) ----------

  // ---------- Tee→Puck fold animation (CSS keyframes via JS frame swap) ----------
  // Use 8 frames extracted via clipping the compression strip
  const foldStage = document.querySelector('.fold-stage');
  if(foldStage){
    const img = foldStage.querySelector('.fold-img');
    const progress = foldStage.querySelector('.fold-progress');
    const FRAMES = 8;
    let frame = 0, dir = 1, raf, lastT = 0, hovering = false;

    // We use a sprite: the strip JPG has 8 stages side by side.
    // Approach: render <div class="frame f0..f7"> as background-positioned slices.
    img.innerHTML = '';
    const sprite = document.createElement('div');
    sprite.className = 'sprite';
    sprite.style.cssText = `
      width:100%; aspect-ratio:1/1; position:relative;
      display:flex;align-items:center;justify-content:center;
    `;
    for(let n=0;n<FRAMES;n++){
      const f = document.createElement('div');
      f.className = 'frame';
      f.style.cssText = `
        position:absolute;inset:0;
        background:url(${(window.LATE_ASSETS && window.LATE_ASSETS.compressionStrip) || ''}) no-repeat;
        background-size:${FRAMES*100}% 100%;
        background-position:${-n*(100/(FRAMES-1))*((FRAMES-1)/FRAMES)*100}% center;
        opacity:${n===0?1:0};
        transition:opacity .12s linear;
        filter:drop-shadow(0 20px 30px rgba(0,0,0,.5));
      `;
      // fine-tune: each frame x offset
      f.style.backgroundPosition = `${(n/(FRAMES-1))*100}% center`;
      sprite.appendChild(f);
    }
    img.appendChild(sprite);
    const frames = sprite.querySelectorAll('.frame');

    function showFrame(n){
      frames.forEach((f,idx)=> f.style.opacity = (idx===n)?'1':'0');
      if(progress) progress.textContent = `${String(n+1).padStart(2,'0')} / 0${FRAMES}`;
    }
    showFrame(0);

    // Idle loop: 0→7→hold→reset, 3.5s out + 1s hold then reset
    const DUR_OUT = reduce ? 800 : 3500;
    const HOLD = 1000;
    let started = false;

    function startLoop(){
      if(started) return;
      started = true;
      let t0 = performance.now();
      function step(t){
        const elapsed = t - t0;
        if(elapsed < DUR_OUT){
          // ease w/ elastic on last 20%
          const p = elapsed / DUR_OUT;
          let eased;
          if(p < 0.8) eased = p/0.8 * 0.85;
          else{
            const q = (p-0.8)/0.2;
            // elastic-ish
            eased = 0.85 + 0.15 * (1 - Math.cos(q * Math.PI * 1.5) * Math.exp(-q*3));
          }
          const f = Math.min(FRAMES-1, Math.round(eased * (FRAMES-1)));
          if(f !== frame){ frame = f; showFrame(f); }
          raf = requestAnimationFrame(step);
        } else if(elapsed < DUR_OUT + HOLD){
          showFrame(FRAMES-1);
          raf = requestAnimationFrame(step);
        } else {
          // restart unless mobile (run once on mobile)
          if(window.innerWidth > 680 && !reduce){
            frame = 0; showFrame(0); t0 = performance.now() + 400; raf = requestAnimationFrame(step);
          } else {
            showFrame(FRAMES-1);
          }
        }
      }
      raf = requestAnimationFrame(step);
    }

    // Trigger on scroll into view
    const foldIO = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if(e.isIntersecting) startLoop(); });
    },{threshold:.35});
    foldIO.observe(foldStage);

    // Hover: snap to puck quickly
    foldStage.addEventListener('mouseenter', ()=>{
      hovering = true;
      cancelAnimationFrame(raf);
      let t0 = performance.now();
      const startFrame = frame;
      function snap(t){
        const p = Math.min(1, (t - t0) / 700);
        const f = Math.round(startFrame + (FRAMES-1 - startFrame) * p);
        if(f !== frame){ frame = f; showFrame(f); }
        if(p < 1) raf = requestAnimationFrame(snap);
      }
      raf = requestAnimationFrame(snap);
    });
    foldStage.addEventListener('mouseleave', ()=>{
      hovering = false;
      if(reduce) return;
      // expand back then resume loop
      cancelAnimationFrame(raf);
      let t0 = performance.now();
      const startFrame = frame;
      function expand(t){
        const p = Math.min(1, (t - t0) / 800);
        const f = Math.round(startFrame + (0 - startFrame) * p);
        if(f !== frame){ frame = f; showFrame(f); }
        if(p < 1) raf = requestAnimationFrame(expand);
        else { started = false; startLoop(); }
      }
      raf = requestAnimationFrame(expand);
    });
  }

  // ---------- FAQ accordion ----------
  document.querySelectorAll('.faq-item').forEach(item=>{
    const q = item.querySelector('.faq-q');
    q.addEventListener('click', ()=>{
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o=> o.classList.remove('open'));
      if(!wasOpen) item.classList.add('open');
    });
  });

})();

/* ============ SHOP ============ */
/* ============================================================
   LATE — shop.js
   Variant switching · Size + qty · Add to bag · ?variant= deep link
   Only runs when the product page is present (.shop-tab + #info-col).
   ============================================================ */
(function(){
  // Only run on the Shop page (which has .shop-panel). Individual product pages
  // also have .shop-tab + #info-col but do NOT have .shop-panel — skip those so
  // we don't overwrite Liquid-rendered product info with hard-coded variant data.
  if(!document.querySelector('.shop-panel')) return;
  if(!document.querySelector('.shop-tab') || !document.getElementById('info-col')) return;

  const VARIANTS = {
    smoke: {
      id:'smoke',
      name:'Smoke.',
      tag:'Everyday flagship · Black',
      eyebrow:'Drop 001 · Core',
      role:'Core',
      price:4000,
      stock:'In stock · Ships in 48h',
      desc:'The core of the lineup. Smoke is the everyday Late tee — tri-blend tech, athletic jersey cut, compression-bonded edges. Folds to under two inches. Forgets you put it on, until you realise you\'re still wearing it at 11pm.',
      spec:{
        fabric:'92% Polyester · 8% Elastane Tri-Blend Tech. Treated weave with anti-bacterial finish.',
        weight:'145 GSM. About the same as a single thick playing card.',
        fit:'Athletic jersey cut — slim through the chest, square at the shoulder, hits at the hip bone. True to size.',
        finish:'Compression-bonded edges. Tonal stitch. Chevron mark woven on the back, screen-applied for refold integrity.'
      },
      isFire:false
    },
    smokeless: {
      id:'smokeless',
      name:'Smokeless.',
      tag:'Performance · Cooling-tuned Black',
      eyebrow:'Drop 001 · Performance',
      role:'Performance',
      price:4000,
      stock:'In stock · Ships in 48h',
      desc:'The performance cut. Same shape, same fold spec — but tuned cooler. A finer weave, deeper moisture-wicking, longer drying loop. Built for the office-to-gym crossover and the 21k weekend.',
      spec:{
        fabric:'88% Recycled Polyester · 12% Elastane. Hollow-core yarn for accelerated drying.',
        weight:'130 GSM. 10% lighter than Smoke, runs cooler under load.',
        fit:'Athletic jersey cut · 2% more taper through the waist for activity overlap.',
        finish:'Compression-bonded edges · Laser-perforated underarm vent · Reflective chevron at the back hem.'
      },
      isFire:false
    },
    fire: {
      id:'fire',
      name:'Black Fire.',
      tag:'Limited · Drop 001 · 800 units globally',
      eyebrow:'Limited · Drop 001',
      role:'Limited',
      price:4000,
      stock:'Waitlist · 247 spots left',
      desc:'The limited edition. Same chassis as Smoke, but every signal flipped to red — woven chevron in poppy, foil-stamped neck label, fire-treated weave with a deeper jet finish. Eight hundred units, ever. After that, it folds for good.',
      spec:{
        fabric:'92% Polyester · 8% Elastane Tri-Blend Tech · Fire-treated jet weave.',
        weight:'145 GSM. Marginally denser than Smoke at the seam.',
        fit:'Athletic jersey cut. Identical to Smoke.',
        finish:'Compression-bonded edges · Poppy-red woven chevron · Foil-stamped neck label · Individually numbered.'
      },
      isFire:true
    }
  };

  let state = {
    variant: 'smoke',
    size: 'S',
    qty: 1,
    bag: 0,
    shot: 'back'
  };

  // Read deep-link
  const params = new URLSearchParams(location.search);
  const initial = params.get('variant');
  if(initial && VARIANTS[initial]) state.variant = initial;

  // ---------- Render ----------
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  function render(){
    const v = VARIANTS[state.variant];

    // Tabs
    $$('.shop-tab').forEach(t=>{
      const active = t.dataset.variant === state.variant;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    // Header info
    $('#info-eye').textContent = v.eyebrow;
    $('#product-name').textContent = v.name;
    $('#product-tag').textContent = v.tag;
    $('#product-desc').textContent = v.desc;
    $('#stock-text').textContent = v.stock;

    // Specs
    $('#spec-fabric').textContent = v.spec.fabric;
    $('#spec-weight').textContent = v.spec.weight;
    $('#spec-fit').textContent = v.spec.fit;
    $('#spec-finish').textContent = v.spec.finish;

    // Fire styling toggles
    const infoCol = $('#info-col');
    const feature = $('#feature');
    infoCol.classList.toggle('fire', v.isFire);
    feature.classList.toggle('fire', v.isFire);
    $$('.thumb').forEach(t=> t.classList.toggle('thumb-fire', v.isFire));

    // You may also like — other two variants
    const also = $('#also-grid');
    also.innerHTML = '';
    Object.values(VARIANTS).filter(o=>o.id !== state.variant).forEach(o=>{
      const a = document.createElement('a');
      a.href = `product.html?variant=${o.id}`;
      a.className = 'also-card' + (o.isFire ? ' fire' : '');
      a.innerHTML = `
        <div class="no">${o.isFire?'03 / Black Fire':(o.id==='smoke'?'01 / Smoke':'02 / Smokeless')}</div>
        <div>
          <h4>${o.name.replace('.','')}</h4>
          <div class="meta"><span>${o.role}</span><span>₹${o.price.toLocaleString('en-IN')}</span></div>
          <span class="explore">Explore <span>→</span></span>
        </div>
      `;
      a.addEventListener('click', (e)=>{
        e.preventDefault();
        state.variant = o.id;
        history.replaceState(null,'',`?variant=${o.id}`);
        render();
        window.scrollTo({top:0,behavior:'smooth'});
      });
      also.appendChild(a);
    });

    // CTAs (fire color etc applied via .fire on info-col)
  }

  // ---------- Tab clicks ----------
  $$('.shop-tab').forEach(tab=>{
    tab.addEventListener('click', ()=>{
      state.variant = tab.dataset.variant;
      history.replaceState(null,'',`?variant=${state.variant}`);
      render();
    });
  });

  // ---------- Size selection ----------
  $$('.size-btn').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      if(btn.disabled) return;
      $$('.size-btn').forEach(b=> b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed','true');
      state.size = btn.dataset.size;
    });
  });

  // ---------- Quantity ----------
  const qtyInput = $('#qty');
  $$('.qty button').forEach(b=>{
    b.addEventListener('click', ()=>{
      const step = parseInt(b.dataset.step,10);
      const next = Math.max(1, Math.min(6, (parseInt(qtyInput.value,10)||1) + step));
      qtyInput.value = next;
      state.qty = next;
    });
  });
  qtyInput.addEventListener('input', ()=>{
    state.qty = Math.max(1, Math.min(6, parseInt(qtyInput.value,10)||1));
    qtyInput.value = state.qty;
  });

  // ---------- Spec accordion ----------
  $$('.spec-row > button').forEach(b=>{
    b.addEventListener('click', ()=>{
      b.parentElement.classList.toggle('open');
    });
  });

  // ---------- Thumbnails ----------
  $$('.thumb').forEach(t=>{
    t.addEventListener('click', ()=>{
      $$('.thumb').forEach(x=> x.setAttribute('aria-selected','false'));
      t.setAttribute('aria-selected','true');
      state.shot = t.dataset.shot;
      // Could swap feature image content; for placeholder, brief pulse:
      const f = $('#feature');
      f.style.transform = 'scale(.98)';
      setTimeout(()=> f.style.transform = '', 200);
    });
  });

  // ---------- Add to bag ----------
  const toast = $('#toast');
  const toastText = $('#toast-text');
  function showToast(msg, fire){
    toastText.textContent = msg;
    toast.classList.toggle('fire', !!fire);
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(()=> toast.classList.remove('show'), 2400);
  }
  // NOTE: add-to-bag is intercepted by cart-drawer.liquid (AJAX add + drawer open).
  // We only show the optional toast here for visual feedback; real cart state is
  // owned by the drawer (which reads /cart.js after each add).
  const addBtn = $('#add-bag');
  if(addBtn){
    addBtn.addEventListener('click', ()=>{
      const v = VARIANTS[state.variant];
      showToast(`Adding · ${v.name.replace('.','')} · ${state.size} × ${state.qty}`, v.isFire);
    });
  }
  const buyBtn = $('#buy-now');
  if(buyBtn){
    buyBtn.addEventListener('click', ()=>{
      const v = VARIANTS[state.variant];
      showToast(`Checking out · ${v.name.replace('.','')} × ${state.qty}`, v.isFire);
    });
  }

  // Boot
  render();
})();

/* ============ SHOP PAGE — variant panel switching ============ */
(function(){
  var rail = document.querySelectorAll('.shop-rail .shop-tab');
  var panels = document.querySelectorAll('.shop-panel');
  if(!rail.length || !panels.length) return;

  function show(v){
    panels.forEach(function(p){
      var match = p.dataset.panel === v;
      if(match) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
    });
    rail.forEach(function(t){
      t.setAttribute('aria-selected', t.dataset.variant === v ? 'true' : 'false');
    });
  }

  // Wire each shop-panel's internal interactions (size, qty, accordion)
  panels.forEach(function(panel){
    panel.querySelectorAll('.size-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(btn.disabled) return;
        panel.querySelectorAll('.size-btn').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
        btn.setAttribute('aria-pressed','true');
        var vid = btn.dataset.variantId;
        var input = panel.querySelector('.variant-id-input');
        if(vid && input) input.value = vid;
      });
    });
    var qty = panel.querySelector('.qty-input');
    panel.querySelectorAll('.qty button').forEach(function(b){
      b.addEventListener('click', function(){
        var step = parseInt(b.dataset.step, 10);
        var next = Math.max(1, Math.min(6, (parseInt(qty.value,10)||1) + step));
        qty.value = next;
      });
    });
    panel.querySelectorAll('.spec-row > button').forEach(function(b){
      b.addEventListener('click', function(){ b.parentElement.classList.toggle('open'); });
    });
  });

  // Tab clicks
  rail.forEach(function(tab){
    tab.addEventListener('click', function(){
      var v = tab.dataset.variant;
      show(v);
      try { history.replaceState(null, '', '?v=' + v); } catch(_) {}
    });
  });

  // Init from URL param
  var p = new URLSearchParams(location.search);
  var initial = p.get('v') || 'smoke';
  if(['smoke','smokeless','fire'].indexOf(initial) === -1) initial = 'smoke';
  show(initial);
})();

/* ============ PARTNERS MAP — scroll-sync between cards and map pins ============ */
(function(){
  var cards = document.querySelectorAll('.partner-card');
  var pins  = document.querySelectorAll('.map-pin');
  var label = document.querySelector('.map-active-label');
  var counter = document.getElementById('map-counter');
  var scope = document.querySelector('.map-scope');
  if(!cards.length || !pins.length) return;

  function activate(idx){
    pins.forEach(function(p, i){
      p.classList.toggle('active', i === idx);
    });
    cards.forEach(function(c, i){
      c.classList.toggle('active', i === idx);
    });
    if(counter){
      counter.textContent = (idx + 1).toString().padStart(2, '0');
    }
    if(label){
      var card = cards[idx];
      var labCode = label.querySelector('.lab-code');
      var labName = label.querySelector('.lab-meta strong');
      var labRole = label.querySelector('.lab-meta em');
      if(labCode) labCode.textContent = card.dataset.code || '';
      if(labName) labName.textContent = card.dataset.name || '';
      if(labRole) labRole.textContent = card.dataset.role || '';
    }
    // Move the scope reticle to the active pin
    if(scope){
      var pin = pins[idx];
      if(pin && pin.parentElement){
        var frame = pin.closest('.map-frame');
        var pinRect = pin.getBoundingClientRect();
        var frameRect = frame.getBoundingClientRect();
        scope.style.left = ((pinRect.left + pinRect.width/2 - frameRect.left) / frameRect.width * 100) + '%';
        scope.style.top  = ((pinRect.top + pinRect.height/2 - frameRect.top) / frameRect.height * 100) + '%';
      }
    }
  }

  var io = new IntersectionObserver(function(entries){
    // Pick the entry most centered in the viewport
    var best = null, bestRatio = 0;
    entries.forEach(function(e){
      if(e.intersectionRatio > bestRatio){
        bestRatio = e.intersectionRatio;
        best = e;
      }
    });
    if(best && best.intersectionRatio > 0.4){
      var idx = parseInt(best.target.dataset.pin, 10);
      if(!isNaN(idx)) activate(idx);
    }
  }, { threshold: [0, 0.25, 0.5, 0.75, 1.0], rootMargin: '-20% 0px -30% 0px' });

  cards.forEach(function(card){ io.observe(card); });

  // Init with first card
  activate(0);
})();
